// Layout kind — Classic / Modern レイアウト種別
// (docs/_wip/pen-usage-analytics-2026-08-18.md §9 レイアウトの計測).
//
// Web 側の `LayoutKind` (`packages/web/src/infrastructure/layoutPreference.ts`)
// と同じ 2 値。純粋なクライアント表示の差 (engine / protocol はレイアウト非依存)
// なので、server にとっては telemetry 用の不透明な 2 値でしかない — server は
// この値で分岐しない (判定に使わない、記録するだけ).
//
// 定義をここ (shared/) に置く理由: `room.join.layout` (入室時レイアウト) と
// `analytics.layout-switch.layout` (切替後の値) の 2 箇所で同じ型を使うため、
// 単一の domain (room.ts / analytics.ts) に属させず shared に切り出した
// (`shared/permissions.ts` 等、他の cross-domain payload piece と同じ置き場).
import { z } from 'zod';
export const LAYOUT_KINDS = ['classic', 'modern'];
export const layoutKindSchema = z.enum(LAYOUT_KINDS);
//# sourceMappingURL=layout.js.map